import { App, Button, Card, Checkbox, Col, Layout, Row, theme, Typography, Spin, Alert } from 'antd';
import { useEffect, useState } from 'react';
import AcceptTermsPageStyles from './AcceptTermPageStyles';
import { getUser, updateUser } from '../../apis/apis';
import { auth, db } from '../../config/firebase';
import { doc, getDoc } from 'firebase/firestore';

const { Title, Paragraph } = Typography;

const AcceptTermsPage = ({ onAccept }: { onAccept: () => void }) => {
  const { token } = theme.useToken();
  const styles = AcceptTermsPageStyles(token);

  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [termsLoading, setTermsLoading] = useState(true);
  const [termsError, setTermsError] = useState<string>('');
  const [termsContent, setTermsContent] = useState<string>('');

  // Language constant: set to 'en' or 'es'
  const LANGUAGE: 'en' | 'es' = 'en';

  const { message } = App.useApp();

  useEffect(() => {
    const loadTerms = async () => {
      try {
        const user = await getUser();
        if (!user?.clientId) {
          setTermsError('No se pudo obtener el cliente.');
          setTermsLoading(false);
          return;
        }
        const clientRef = doc(db, 'Clients', user.clientId);
        const snap = await getDoc(clientRef);
        if (snap.exists()) {
          const data: any = snap.data();
          let terms = '';
          if (data.terms && typeof data.terms === 'object' && data.terms[LANGUAGE]) {
            terms = data.terms[LANGUAGE];
          } else {            
            terms = '';
          }
          setTermsContent(String(terms || ''));
        }
      } catch (e) {
        setTermsError('Error cargando Términos y Condiciones');
      } finally {
        setTermsLoading(false);
      }
    };
    loadTerms();
  }, []);

  const handleCheckboxChange = (e: { target: { checked: boolean } }) => {
    setAccepted(e.target.checked);
  };

  async function handleAcceptTerms() {
    if (!auth.currentUser) {
      message.error('Error al obtener el usuario');
      return;
    }

    const user = await getUser();
    if (!user) {
      message.error('Error al obtener datos del usuario');
      return;
    }

    user.acceptedTerms = true;
    setLoading(true);
    const result = await updateUser(user);
    if (!result) {
      console.error('Error creating user');
      setLoading(false);
      return;
    }
    setLoading(false);
    onAccept();
  }

  return (
    <Layout style={styles.content}>
      <Row justify="center" style={{ width: '100%' }}>
        <Col xs={22} sm={20} md={16} lg={14} xl={12}>
          <Card style={styles.card}>
            <Title level={4}>{'Términos y Condiciones de Uso'}</Title>
            {termsLoading ? (
              <Spin />
            ) : termsError ? (
              <Alert type="error" message={termsError} />
            ) : (
              <Paragraph>
                {termsContent ? (
                  <div dangerouslySetInnerHTML={{ __html: termsContent }} />
                ) : (
                  ''
                )}
              </Paragraph>
            )}
            <Paragraph>¿Aceptas los Términos y Condiciones?</Paragraph>
            <Checkbox onChange={handleCheckboxChange}>
              <span style={styles.checkboxLabel}>Sí, he leído, entiendo y acepto los Términos y Condiciones.</span>
            </Checkbox>
            <Button
              type="primary"
              onClick={handleAcceptTerms}
              style={styles.button}
              disabled={!accepted}
              loading={loading}
            >
              CONTINUAR AL CHAT
            </Button>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
};

export default AcceptTermsPage;
